/*
https://gist.github.com/softwarespot/76252a838efdcace2df1f9c724e37351
function evaluate(code, args = {}) {
    // Call is used to define where "this" within the evaluated code should reference.
    // eval does not accept the likes of eval.call(...) or eval.apply(...) and cannot
    // be an arrow function
    return function evaluateEval() {
        // Create an args definition list e.g. "arg1 = this.arg1, arg2 = this.arg2"
        const argsStr = Object.keys(args)
            .map(key => `${key} = this.${key}`)
            .join(',');
        const argsDef = argsStr ? `var ${argsStr};` : '';

        return eval(`${argsDef}${code}`);
    }.call(args);
}*/

/*function evaluate(code, args = {}) {
    console.log(new Function(...Object.keys(args), `return ${code}`).toString());
    return new Function(...Object.keys(args), `return ${code}`)(...Object.values(args));
}*/

function evaluate(code: string, args = {}) {
    return new Function(...Object.keys(args), `return ${code} || 0`)(...Object.values(args));
}

// based on: https://stackoverflow.com/a/2843509/1149311
export const mathString = (str: string, args: object, formats: {forAll?: (any: any) => string, [key: string]: (any: any) => string}) => {
    let evalResult = false;
    let replaced = str.replace(/\#\{([^#]+)\}/g, function(match, key) {
        key = key.split(":");
        key[1] = key[1] || formats.forAll ? "forAll" : undefined;
        if (key[0] === "=") {
            evalResult = true;
            return '#{' + key.join(":") + '}';
        }
        if (key[1]) {
            return '#{(' + evaluate(key[0], args) + '):' + key[1] + '}';
        } else {
            return evaluate(key[0], args);
        }
    });
    if (evalResult) {
        let calc = str.replace(/\#\{([^#]+)\}/g, function (match, key) {
            key = key.split(":");
            if (key[0] === "=") {
                return '';
            }
            return evaluate(key[0], args);
        });
        calc = calc.replace(/[^\d\(\)\+\-\^\/\%\*]+/g, '');
        let result = evaluate(calc, args);
        return replaced.replace(/\#\{([^#]+)\}/g, function (match, key) {
            key = key.split(":");
            if (key[0] === "=") {
                key[0] = result;
            }
            if (key[1]) {
                return evaluate( key[1] + '(' + key[0] + ')', formats);
            } else {
                return evaluate(key[0], formats);
            }
        });
    } else {
        return replaced.replace(/\#\{([^#]+)\}/g, function (match, key) {
            return evaluate(key, formats);
        });
    }
}